export const CHECK_COMMENTS_COUNT = "CHECK_COMMENTS_COUNT";
export const SUBMIT_FEEDBACK = "SUBMIT_FEEDBACK";



// WEBPACK FOOTER //
// ./src/features/feedbacks/actionTypes.js